import { Injectable } from '@angular/core';

@Injectable()
export class AuthService {

  tokenSwapi = 'X';
  tokenPokeapi = 'Y';

}
